import { DateRange } from 'react-day-picker';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { axiosInstance } from 'api/axios';
import { routes } from 'api/routes';
import { getAnalyticsDateParams } from '../functions';
import { TemplateAnalytics } from '../get-template-analytics/types';

const get = async ({
  queryKey,
}: QueryFunctionContext<[string, number, string, DateRange]>) => {
  const [, appId, templateId, date] = queryKey;
  const params = getAnalyticsDateParams(date);
  if (!params) return null;

  const { data } = await axiosInstance.get<TemplateAnalytics[]>(
    `${routes['analytics']}/apps/${appId}/templates/${templateId}`,
    {
      params,
    },
  );

  return data;
};

const useGetTemplateDetailsAnalytics = (
  appId: number,
  templateId: string,
  date: DateRange,
) => {
  return useQuery({
    queryKey: [`${routes['analytics']}/templates`, appId, templateId, date],
    queryFn: get,
    enabled: Boolean(appId) && Boolean(templateId),
  });
};

export default useGetTemplateDetailsAnalytics;
